import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';

export const NotificationSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: 4 }, (_, index) => (
        <Skeleton key={index} className="w-full h-12" />
      ))}
    </div>
  );
};
